import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { AdminClient } from "../../repsaApi";

const client = new AdminClient(app_uri, axiosClient());

export default client;
